import { useState, useEffect, useCallback, useMemo } from "react";
import "styles/NavBar/NavBar.css";
import ItemNav from "components/NavBar/ItemNav";
import { Menu } from "components/NavBar/menuConfig";
import Profile from "components/NavBar/Profile";
import TenantLogo from "components/TenantLogo";
import { useUser } from "context";
import { useNavigate, useLocation } from "react-router-dom";
import { useAccess } from "hooks/auth";

function getFilteredMenu(menu_list = [], menu_to_filter = "", filter = true) {
  if (filter) {
    return menu_list.filter((menu) => menu.title !== menu_to_filter);
  }
  return menu_list;
}

export const NavBar = () => {
  const can_access_home_page = useAccess(89);
  const can_access_client_page = useAccess(1);
  const can_access_sous_traitants_page = useAccess(13);
  const can_access_demande_page = useAccess(24);
  const can_access_commande_page = useAccess(39);
  const can_access_admin_page = useAccess(45);

  const [collapse, setCollapse] = useState(
    JSON.parse(localStorage.getItem("navbarCollapse")) || false,
  );
  const { logout } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const activePath = location.pathname;

  const filtered_menu = useMemo(() => {
    let m = Menu;
    m = getFilteredMenu(m, "Accueil", !can_access_home_page);
    m = getFilteredMenu(m, "Clients", !can_access_client_page);
    m = getFilteredMenu(m, "Sous traitants", !can_access_sous_traitants_page);
    m = getFilteredMenu(m, "Demande", !can_access_demande_page);
    m = getFilteredMenu(m, "Commande", !can_access_commande_page);
    m = getFilteredMenu(m, "Admin", !can_access_admin_page);
    return m;
  }, [
    can_access_admin_page,
    can_access_client_page,
    can_access_commande_page,
    can_access_demande_page,
    can_access_home_page,
    can_access_sous_traitants_page,
  ]);

  useEffect(() => {
    localStorage.setItem("navbarCollapse", JSON.stringify(collapse));
  }, [collapse]);

  const clickMenu = useCallback(
    (code) => {
      navigate("/" + code.replace(/\s+/g, "-"));
    },
    [navigate],
  );

  const clickCollapse = () => {
    setCollapse((prevCollapse) => !prevCollapse);
  };

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  useEffect(() => {
    if (activePath === "/Accueil" && !can_access_home_page) {
      const redirection_link =
        filtered_menu.length > 0
          ? `/${filtered_menu[0]?.title.replace(/\s+/g, "-")}`
          : "/No-access";
      navigate(redirection_link);
    }
  }, [activePath, can_access_home_page, filtered_menu, navigate]);

  return (
    <div className="nav-admin">
      <div className="div">
        <div className={"logo " + (collapse && "logo-collapse ")}>
          <TenantLogo
            className={"img " + (collapse ? "img-collapse" : "img-default")}
            collapsed={collapse}
          />

          <div
            className={"cursor-pointer " + (collapse ? "button-collapse" : "button")}
            onClick={clickCollapse}
          >
            <img className="img-2" src="img/mingcute_left-small-line.svg" alt="" />
          </div>
        </div>
        <div className={"menu " + (collapse && " menu-collapse")}>
          {filtered_menu.map((item) => (
            <ItemNav
              key={item.id}
              image={item.image}
              title={item.title}
              selected={`/${item.title.replace(/\s+/g, "-")}` === activePath}
              end={item.end}
              collapse={collapse}
              onClick={() => clickMenu(item.title)}
            />
          ))}
        </div>
        <div className={"frame " + (collapse && "frame-collapse ")}>
          <Profile collapse={collapse} />
          <div className="button-ghostwhite cursor-pointer" onClick={handleLogout}>
            {!collapse && <div className="label-2">Se déconnecter</div>}
            <img className="img-2" src="img/mingcute_power-line.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NavBar;
